import { Component, Vue, Watch } from 'vue-property-decorator';
import { IRadarListing, INotifier } from '../../../models/radar.listing';
import ListingsTableExpand from './ExpandRow/expand.vue';
import EditNotifier from './EditNotifier/edit.notifier.vue';
import EditInstruction from './EditInstruction/edit.instruction.vue';
import EditLockbox from './EditLockBox/edit.lockbox.vue';
import * as T_T from 'cryface';
import { ListingsListDelegate } from '../../../services/DataDelegate/ListingsDelegate/listings.list.delegate';
import { ListingsRestfulDelegate } from '../../../services/DataDelegate/ListingsDelegate/listings.restful.delegate';

@Component({
   components: {
      ListingsTableExpand,
      EditNotifier,
      EditInstruction,
      EditLockbox
   }
})
export default class ListingsTable extends Vue {
   public title: string = 'ListingsTable';

   public data: IRadarListing[] = [];

   public toEditIndex: number = -1;
   public toEditNotifierTwoShow: boolean = false;
   public toEditNotifierOneShow: boolean = false;
   public toEditInstructionShow: boolean = false;
   public toEditLockboxShow: boolean = false;
   public listDelegate = new ListingsListDelegate();
   public restfulDelegate = new ListingsRestfulDelegate();

   public columnsMain: any[] = [
      {
         type: 'expand',
         width: 50,
         render: (h: any, params: any) => {
            return h(ListingsTableExpand, {
               props: {
                  row: params.row
               }
            });
         }
      },
      {
         title: 'Address',
         width: 250,
         slot: 'address',
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'MLS Number',
         width: 150,
         slot: 'mls_number',
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'L-Agent1',
         width: 140,
         slot: 'listing_agent_one'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'L-Agent2',
         width: 140,
         slot: 'listing_agent_two'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'Vendor1',
         width: 140,
         slot: 'notifier_one'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'Vendor2',
         width: 140,
         slot: 'notifier_two'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'Instruction',
         width: 200,
         slot: 'instruction',
      },
      {
         title: 'LockBox',
         width: 150,
         slot: 'lockbox'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'Created Date',
         width: 150,
         slot: 'created_date'
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
   ];

   public listupdateTimestamp = new Date();

   public reset = true;

   public totalItems = 100;

   public current = 1;

   // lifecycle hook
   public async created() {
      this.$store.commit('listingStartFetching');
      await this.listDelegate.getListings(1);
      this.totalItems = this.listDelegate.TotalItems;
      this.current = this.listDelegate.CurrentPage;
      this.$store.commit('updateListings');
      this.$store.commit('listingEndFetching');
   }

   public reload() {
      this.reset = false;
      this.$nextTick(() => (this.reset = true));
   }

   @Watch('$store.state.listings.list', { deep: true, immediate: true })
   public onDataChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.data = val.data;
         this.listupdateTimestamp = val.timestamp;
         this.reload();
      }
   }

   public trunc(str: string) {
      return T_T.trunc(str, 15, '...');
   }

   public editNotifierOne(index: number) {
      this.toEditIndex = index;
      this.toEditNotifierOneShow = true;
   }

   public async onNotifierSaveOne(index: number, notifier: INotifier, data: IRadarListing) {
      this.$store.commit('listingStartFetching');
      this.toEditNotifierOneShow = false;
      data.notifier_one = notifier;
      await this.restfulDelegate.addNotifier(notifier, data.id);
      await this.listDelegate.getListings(1);
      this.$store.commit('updateListings');
      this.$store.commit('listingEndFetching');
      this.$Notice.success(
         {
            title: 'Succeed',
            desc: `Saved Changes For: <br> ${this.data[index].mls_number}`
         }
      );
      // window.location.reload();
   }

   public onNotifierCancelOne() {
      this.toEditNotifierOneShow = false;
   }

   public editNotifierTwo(index: number) {
      this.toEditIndex = index;
      this.toEditNotifierTwoShow = true;
   }

   public async onNotifierSaveTwo(index: number, notifier: INotifier, data: IRadarListing) {
      this.$store.commit('listingStartFetching');
      this.toEditNotifierTwoShow = false;
      data.notifier_two = notifier;
      await this.restfulDelegate.addNotifier(notifier, data.id);
      await this.listDelegate.getListings(1);
      this.$store.commit('updateListings');
      this.$store.commit('listingEndFetching');
      this.$Notice.success(
         {
            title: 'Succeed',
            desc: `Saved Changes For: <br> ${this.data[index].mls_number}`
         }
      );
      // window.location.reload();
   }

   public onNotifierCancelTwo() {
      this.toEditNotifierTwoShow = false;
   }

   public editInstruction(index: number) {
      this.toEditIndex = index;
      this.toEditInstructionShow = true;
   }

   public async onUpdateListing(index: number, data: IRadarListing) {
      this.$store.commit('listingStartFetching');
      await this.restfulDelegate.updateListing(data.id, data);
      this.toEditInstructionShow = false;
      this.$store.commit('listingEndFetching');
      this.$Notice.success(
         {
            title: 'Succeed',
            desc: `Saved Changes For: <br> ${this.data[index].mls_number}`
         }
      );
      // window.location.reload();
   }

   public onInstructioCancelOne() {
      this.toEditInstructionShow = false;
   }

   public editLockbox(index: number) {
      this.toEditIndex = index;
      this.toEditLockboxShow = true;
   }

   public onLockboxCancelOne() {
      this.toEditLockboxShow = false;
   }

   public destroyed() {
      this.restfulDelegate.clearData();
      this.listDelegate.clearData();
   }

   public async onPageChange(pageNum: number) {
      this.$store.commit('listingStartFetching');
      const result = await this.listDelegate.getListings(pageNum);
      if (result === 1) {
         this.$store.commit('updateListings');
      } else {
         this.$Notice.error(
            {
               title: 'Error',
               desc: `Failed To Get Data`
            }
         );
      }
      this.$store.commit('listingEndFetching');
   }

}
